import { EnvVars } from '../../environment';

// TODO: update FE code to use this directly & update endpoints to import
export const APIBaseChronos = EnvVars.API_URL;
